function hasFeature(name, fguInstitutions) {
  const institutionNumber = location.pathname.split("/")[1];
  const fguInstitution = fguInstitutions?.find((fgu) => fgu.institutionNumber === institutionNumber);
  const feature = name + "Enabled";
  return fguInstitution?.[feature] || false;
}

export const features = {
  install(app) {
    app.config.globalProperties.$hasFeature = (feature) => hasFeature(feature, app.config.globalProperties.$store.state.session.tokenData?.fguInstitutions);
  },
};
